import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { PreviewResults } from './PreviewResults';
import { FilterFlowDataProps } from '../FilterFlow';
import ReportsCohortItem from '../ReportsCohortItemNew';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import componentConstants from '../../../core-utils/messages/componentConstants';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { scrollBarStyles } from '../../../core-utils/messages/CommonConstants';

interface ModalFilterProps {
  totalResults: number;
  handleDeleteCohort: (_itemIndex: number, _refresh?: any) => void;
  handleAddCohort: () => void;
  data: FilterFlowDataProps[];
  isLoading: boolean;
  existingMemberUniqueIds?: string[];
}

const useStyles = makeStyles()({
  cohortDetailsContainer: {
    overflowY: 'auto',
    paddingRight: '1rem',
    marginBottom: '1rem',
    ...scrollBarStyles,
  },
});

const ModalFilter = ({
  totalResults,
  handleDeleteCohort,
  handleAddCohort,
  data,
  isLoading,
  existingMemberUniqueIds,
}: ModalFilterProps) => {
  const messages = componentConstants.ORGANISMS.COHORT_DETAILS;
  const { classes } = useStyles();

  return (
    <Box
      className={classes.cohortDetailsContainer}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <ReportsCohortItem
          totalResults={totalResults}
          handleDeleteCohort={handleDeleteCohort}
          existingMemberUniqueIds={existingMemberUniqueIds}
        />
        <Typography
          fontSize="14px"
          lineHeight="28px"
          cursor="pointer"
          fontType="medium"
          textColor={patientAccessTheme.palette.primary[500]}
          onClick={handleAddCohort}
        >
          {messages.ADD_COHORTS}
        </Typography>
      </Box>
      <PreviewResults data={data} isLoading={isLoading} />
    </Box>
  );
};

export default ModalFilter;
